// テンプレート管理
import { updateAllTemplates, updateSelectedTemplate, allTemplates } from "./state.js";

// テンプレートJSONを読み込む関数
export const fetchTemplates = async () => {
  try {
    const response = await fetch("./templates.json"); // webpack-dev-serverのpublicPathを考慮
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    const templates = await response.json();
    updateAllTemplates(templates);
    console.log("Templates loaded:", templates);
    return templates;
  } catch (error) {
    console.error("Failed to load templates:", error);
    throw error;
  }
};

// テンプレート選択の処理
export const handleTemplateSelection = (templateId, templateThumbnailImageElement, templateThumbnailPlaceholderElement) => {
  updateSelectedTemplate(templateId);

  // 新しいテンプレート選択ボタンのテキストも更新
  const templatePreviewButton = document.getElementById("btn_template_preview");
  if (templatePreviewButton && templateId) {
    const selectedTemplate = allTemplates.find((t) => t.templateId === templateId);
    if (selectedTemplate) {
      templatePreviewButton.textContent = selectedTemplate.name;
    }
  } else if (templatePreviewButton) {
    templatePreviewButton.textContent = "フレームを選択する";
  }

  if (templateId && templateThumbnailImageElement && templateThumbnailPlaceholderElement) {
    // 新しいサムネイル画像パスルール: /assets/album_templates/thumbnail/{templateId}.jpg
    templateThumbnailImageElement.src = `/assets/album_templates/thumbnail/${templateId}.jpg`;
    templateThumbnailImageElement.style.display = "block";
    templateThumbnailPlaceholderElement.style.display = "none";
  } else if (templateThumbnailImageElement && templateThumbnailPlaceholderElement) {
    templateThumbnailImageElement.src = "";
    templateThumbnailImageElement.style.display = "none";
    templateThumbnailPlaceholderElement.style.display = "block";
  }
};

// layout.jsonを読み込む関数
export const loadLayoutData = async () => {
  try {
    const response = await fetch("./layout.json");
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    const layoutData = await response.json();
    console.log("Layout data loaded:", layoutData);
    return layoutData;
  } catch (error) {
    console.error("Layout data loading failed:", error);
    return null;
  }
};
